<template>
    <div>
            <v-navigation-drawer
                    fixed
                    :clipped="$vuetify.breakpoint.mdAndUp"
                    app
                    v-model="drawer"
                    :enable-resize-watcher="drawer"
                    class="navDrawer mainNavDrawer"
            >
                <!-- List of items in Nav Drawer -->
                <v-list dense class="primary--text">
                    <template v-for="(item, i) in clientItems">
                        <!-- Items with title witch are not expanding -->
                        <v-list-item
                                :key="i"
                                v-if="item.title"
                                router
                                :to="item.link"
                        >
                            <v-list-item-action>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <!-- Expanding main group section -->
                        <v-list-group
                                :key="i"
                                v-else-if="item.title_expand"
                        >
                            <!-- Main title -->
                            <v-list-item slot="activator">
                                <v-list-item-action>
                                    <v-icon color="grey darken-1">{{item.icon}}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title>{{item.title_expand}}</v-list-item-title>
                            </v-list-item>
                            <!-- Subtitles -->
                            <v-list-item
                                    v-for="(item, i) in item.subtitles"
                                    :key="i"
                                    router
                                    :to="item[1]"
                            >
                                <v-list-item-action>
                                    <v-icon>{{item.icon}}</v-icon>
                                </v-list-item-action>
                                <v-list-item-title>{{ item[0] }}</v-list-item-title>
                            </v-list-item>
                            <!-- Sub Expanding group 1-->
                            <v-list-group
                                    sub-group
                                    no-action
                                    v-if="item.sub_group1_children"
                            >
                                <!-- Title -->
                                <v-list-item
                                        slot="activator"
                                        class="remove-bcg-hov"
                                >
                                    <v-list-item-title>{{item.sub_group1_title}}</v-list-item-title>
                                </v-list-item>
                                <!-- Item title -->
                                <v-list-item
                                        v-for="(item, i) in item.sub_group1_children"
                                        :key="i"
                                        router
                                        :to="item[1]"
                                >
                                    <v-list-item-title>{{ item[0] }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <!-- Sub Expanding group 2-->
                            <v-list-group
                                    sub-group
                                    no-action
                                    v-if="item.sub_group2_children"
                            >
                                <!-- Title -->
                                <v-list-item
                                        slot="activator"
                                        class="remove-bcg-hov"
                                >
                                    <v-list-item-title>{{item.sub_group2_title}}</v-list-item-title>
                                </v-list-item>
                                <!-- Item title -->
                                <v-list-item
                                        v-for="(item, i) in item.sub_group2_children"
                                        :key="i"
                                        router
                                        :to="item[1]"
                                >
                                    <v-list-item-title>{{ item[0] }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                            <v-list-group
                                    sub-group
                                    no-action
                                    v-if="item.sub_group3_children"
                            >
                                <!-- Title -->
                                <v-list-item
                                        slot="activator"
                                        class="remove-bcg-hov"
                                >
                                    <v-list-item-title>{{item.sub_group3_title}}</v-list-item-title>
                                </v-list-item>
                                <!-- Item title -->
                                <v-list-item
                                        v-for="(item, i) in item.sub_group3_children"
                                        :key="i"
                                        router
                                        :to="item[1]"
                                >
                                    <v-list-item-title>{{ item[0] }}</v-list-item-title>
                                </v-list-item>
                            </v-list-group>
                        </v-list-group>
                    </template>
                </v-list>
            </v-navigation-drawer>
            <!-- Toolbar     -->
            <v-app-bar
                id="toolbar"
                dark
                class="header"
                :class="`${getContrast($vuetify.theme.themes.light.header)}--text`"
                app
                :clipped-left="$vuetify.breakpoint.mdAndUp"
                extension-height="56px"
                fixed>
                <v-app-bar-nav-icon
                    :class="`${getContrast($vuetify.theme.themes.light.header)}--text`"
                    @click.stop="drawer = !drawer"
                ></v-app-bar-nav-icon>
                <router-link
                    v-if="
                        !no_data.includes(organizationSettings) &&
                        !no_data.includes(organizationSettings.client_portal_logo)
                    "
                    to="/"
                    style="cursor:pointer"
                >
                    <img id="custom-logo-portal" :src="organizationSettings.client_portal_logo" style="vertical-align: text-bottom;" alt="Sweep and Go Logo"/>
                </router-link>
                <router-link v-else to="/" style="cursor:pointer">
                    <img id="logo-portal" :src="logo" style="vertical-align: text-bottom;" alt="Sweep and Go Logo"/>
                    <img id="logo-portal-small" :src="small_logo" style="vertical-align: text-bottom;" alt="Sweep and Go Logo"/>
                </router-link>
                <v-spacer></v-spacer>
                <v-toolbar-title :class="`${getContrast($vuetify.theme.themes.light.header)}--text`" style="font-size: 12px; font-weight: normal; padding-left: 5px; padding-right: 5px;">{{ `v${version}` }}</v-toolbar-title>
                <v-toolbar-title v-if="$vuetify.breakpoint.smAndUp && clientType === 'commercial'" :class="`${getContrast($vuetify.theme.themes.light.header)}--text`" style="font-size: 12px; font-weight: normal; padding-left: 5px; padding-right: 5px;">
                    <locations></locations>
                </v-toolbar-title>
                <v-toolbar-items class="toolbar-items">
                    <v-layout class="align-center fill-height mr-1">

                    <v-menu v-if="clientType === 'residential'" light offset-y bottom left content-class="fixed-many">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" dark icon class="toolbar-icons" :class="`${getContrast($vuetify.theme.themes.light.header)}--text`">
                                <v-badge top color="error" :bordered="getTwoColorContrast($vuetify.theme.themes.light.header, '#ff5252', true) <= 2" :overlap="true" :value="notificationShow">
                                    <template v-slot:badge>
                                        <span small style="font-size: 12px;">{{new_notifications > 9 ? '9+' : new_notifications}}</span>
                                    </template>
                                    <v-icon>notifications</v-icon>
                                </v-badge>
                            </v-btn>
                        </template>

                        <v-list three-line style="width: 300px;">
                            <div class="d-flex pt-1 pb-2 px-4">
                                <span class="mr-1">{{new_notifications}}</span>
                                <div class="d-inline-block">Notifications</div>
                                <v-spacer></v-spacer>
                                <v-icon style="max-width: 24px; font-size: 18px; cursor: pointer;">close</v-icon>
                            </div>
                            <v-divider></v-divider>
                            <div class="d-flex px-4 pt-2" justify-space-between>
                                <router-link v-bind:to="'/notification_settings'">
                                    Settings
                                </router-link>
                                <v-spacer></v-spacer>
                                <a href="" class="text-xs-right" @click.prevent="markAsReadNotifications()">View All</a>
                            </div>
                        </v-list>
                    </v-menu>

                    <v-menu light offset-y bottom left content-class="fixed-many">
                        <template v-slot:activator="{ on }">
                            <v-avatar v-on="on" size="30" :color="getContrast($vuetify.theme.themes.light.header) === 'black' ? 'accent' : 'white'" class="toolbar-icons pointer ml-1">
                                <v-img v-if="!no_data.includes(user) && !no_data.includes(user.avatar)" cover aspect-ratio="1" :src="user.avatar" alt="User avatar" />
                                <span v-else class="title" :class="getContrast($vuetify.theme.themes.light.header) === 'black' ? 'white--text' : 'accent--text'">{{ user.full_name.charAt(0)}}</span>
                            </v-avatar>
                        </template>
                        <v-card three-line style="width: 300px;">
                            <v-list class="py-0">
                                <div @click.stop="" class="py-2">
                                <v-list-item>
                                    <v-list-item-avatar color="accent" style="justify-content: center;">
                                        <v-img v-if="!no_data.includes(user.avatar)" cover aspect-ratio="1" :src="user.avatar" alt="User avatar" />
                                        <span v-else class="title" style="color: #fff;">{{ user.full_name.charAt(0)}}</span>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title>{{ user.full_name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ user.organization_name }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                </div>
                            </v-list>
                            <v-divider></v-divider>
                            <v-list>
                                <template v-if="organizations.length">
                                    <div class="px-4 mt-1 mb-1 black--text" @click.stop="">Select Another Account</div>
                                    <v-list-item v-for="(item, index) in organizations" :key="index" @click="changeOrganization(item)">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.full_name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.organization_name }}</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <div class="mb-2"></div>
                                    <v-divider></v-divider>
                                </template>
                                <v-list-item
                                    @click="$router.push('/change_password')"
                                >
                                    <v-list-item-title style="font-size: 13px;">Change Password</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    @click="$router.push('/change_email')"
                                >
                                    <v-list-item-title style="font-size: 13px;">Change Email</v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item
                                    @click="callLogout"
                                    color="primary"
                                >
                                    <v-list-item-title class="text-uppercase" style="font-size: 14px;">Logout</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>
                    </v-layout>
                </v-toolbar-items>
                <v-layout v-if="!$vuetify.breakpoint.smAndUp && clientType === 'commercial'" slot="extension">
                    <locations></locations>
                </v-layout>
            </v-app-bar>
        <v-main>
            <notification-message></notification-message>
            <v-container id="main-content" :class="bodyClass" fluid fill-height>
                <v-layout justify-center align-center>
                    <main role="main" class="container pa-0 px-sm-3 pb-sm-3 pt-sm-9">
                        <router-view v-on:newClass="addNewClass($event)" :key="$route.path"></router-view>
                    </main>
                </v-layout>
                <light-box></light-box>
            </v-container>
        </v-main>
    </div>
</template>
<script>
    import NotificationMessage from './NotificationMessage';
    import LightBox from './LightBox';
    import Locations from './CommercialClients/Locations';
    import {PUSHER_KEY} from "../common/config";
    import Pusher from 'pusher-js'
    import {getOrganizationId, getUserId} from "../common/jwt.service";
    import ApiService from "@/common/api.service";
    import { mapGetters, mapState, mapActions } from "vuex"

    export default {
        components: {
            NotificationMessage,
            LightBox,
            Locations
        },
        data: () => ({
            no_data: [null, '', undefined, 'null'],
            bodyClass:"",
            logo: require('@/assets/img/logo.png'),
            small_logo: require('@/assets/img/footer-logo.png'),
            dialog: false,
            drawer: true,
            loading: true,
            new_messages: 0,
            new_notifications: 0,
            notificationShow: false,
            messageShow: false,
            notification_items: [],
            items: [
                {
                    icon: 'home', title: 'Home', link: '/'
                },
                {
                    icon: 'person', title_expand: 'My Profile',
                    subtitles: [
                        ['Contact Info', '/contact_info'],
                        ['Location', '/location'],
                        ['Dog Info', '/dog_info'],
                        ['Yard Info', '/yard_info']
                    ]
                },
                {
                    icon: 'today', title: 'Cleanups', link: '/cleanups'
                },
                {
                    icon: 'receipt', title_expand: 'Billing',
                    subtitles: [
                        ['Subscriptions','/subscriptions'],
                        ['Invoices','/invoices'],
                        ['Payments','/payments'],
                        ['Tips','/tips'],
                        ['Payment Methods','/payment_methods'],
                    ]
                },
                {
                    icon: 'assignment', title: 'Additional services', link: '/additional_services'
                },
                {
                    icon: 'settings', title_expand: 'Settings',
                    subtitles: [
                        ['Notifications','/notification_settings'],
                        ['Change Password', '/change_password'],
                        ['Change Email', '/change_email']
                    ],
                },

            ],
            commercialItems: [
                {
                    icon: 'home', title: 'Home', link: '/'
                },
                {
                    icon: 'perm_contact_calendar', title: 'Contact Info', link: '/commercial_contact_info'
                },
                {
                    icon: 'receipt', title: 'Billing Info', link: '/commercial_billing_info'
                },
                {
                    icon: 'place', title: 'Service Address', link: '/commercial_service_address'
                },
                {
                    icon: 'mode_of_travel', title: 'Work Areas', link: '/commercial_work_areas'
                },
                {
                    icon: 'local_atm', title: 'Billing', link: '/commercial_billing'
                },
                {
                    icon: 'payments', title: 'Tips', link: '/commercial_tips'
                },
                {
                    icon: 'add_shopping_cart', title: 'Additional Services', link: '/commercial_additional_services'
                },
                {
                    icon: 'today', title: 'Schedule', link: '/commercial_schedule'
                },
                {
                    icon: 'settings', title_expand: 'Settings',
                    subtitles: [
                        ['Change Password', '/change_password'],
                        ['Change Email', '/change_email'],
                    ],
                },

            ]
        }),
        filters: {
            timeFromNow: function (value) {
                if (value) {
                    return moment(value, "YYYYMMDD").fromNow();
                }
            },
        },
        props: {
            source: String
        },
        beforeMount() {
            this.navDrawerMobile()
        },
        created(){
            this.subscribeNotifications();
            this.pullUnreadNotifications();
        },
        mounted() {
        },
        methods: {
            ...mapActions(['switchOrganization', 'logout']),
            subscribeNotifications() {
                let pusher = new Pusher(PUSHER_KEY, {
                    cluster: 'us2',
                    forceTLS: true
                });
                let organization_id = getOrganizationId();
                let user_id = getUserId();
                let channel = pusher.subscribe('notifications.'+organization_id+'.'+user_id);
                channel.bind('NotificationPosted', data => {
                    this.new_notifications += 1;
                    this.notificationShow = true;
                });
            },
            pullUnreadNotifications() {
                if (this.clientType === 'residential') {
                    ApiService.get('client/notification/count_unread_notifications').then(response => {
                        let unreadNotifications = response.data.notifications;
                        if(unreadNotifications){
                            this.notificationShow = true;
                            this.new_notifications+=unreadNotifications;
                        }
                    });
                }
            },
            markAsReadNotifications(){
                this.notificationShow = false;
                this.new_notifications = 0;
                this.$router.push({name: "notifications"});
            },
            addNewClass(event){
                this.bodyClass = event;
            },
            callLogout(event) {
                this.logout(this.organizationSlug)
                    .then(response => {
                        this.$router.push(`/login${!this.no_data.includes(response) ? '/' + response : ''}`)
                    })
            },
            navDrawerMobile() {
                if (window.innerWidth < 1264) {
                    this.drawer = false;
                } else {
                    this.drawer = true;
                }
            },
            changeOrganization (item) {
                let payload = {
                    organization_id: item.organization_id,
                    client_id: item.client_id,
                    commercial_client_id: item.commercial_client_id
                }
                this.switchOrganization(payload)
                    .then(() => {
                        this.$router.go(0)
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },
        computed: {
            ...mapGetters({
                user: 'currentUser',
                clientType: 'clientType',
                tipsEnabled: 'tipsEnabled',
                organizationSettings: 'organizationSettings',
                getContrast: 'getContrast',
                getTwoColorContrast: 'getTwoColorContrast',
                organizationSlug: 'organizationSlug'
            }),
            ...mapState({
                version: state => state.auth.version
            }),
            clientItems: function () {
                let residentialItems = _.cloneDeep(this.items)
                let commercialItems = _.cloneDeep(this.commercialItems)
                if (!this.tipsEnabled) {
                    residentialItems = residentialItems.filter(
                        i => i.title !== 'Tips' && i.title_expand !== 'Tips'
                    )
                    residentialItems.forEach(i => {
                        if (!this.no_data.includes(i.subtitles)) {
                            i.subtitles = i.subtitles.filter(s => s[0] !== 'Tips')
                        }
                    })
                    commercialItems = commercialItems.filter(
                        i => i.title !== 'Tips' && i.title_expand !== 'Tips'
                    )
                    commercialItems.forEach(i => {
                        if (!this.no_data.includes(i.subtitles)) {
                            i.subtitles = i.subtitles.filter(s => s[0] !== 'Tips')
                        }
                    })
                }
                return this.clientType === 'commercial' ? commercialItems : residentialItems
            },
            organizations: function () {
                let output = []
                if(!this.no_data.includes(this.user) && !this.no_data.includes(this.user.organizations)) {
                    output = this.user.organizations.filter(i => 
                        `${i.organization_id}-${i.client_id}-${i.commercial_contact_id}` !== 
                        `${this.user.organization_id}-${this.user.client_id}-${this.user.commercial_contact_id}`
                    )
                }
                return output
            }
        }
    };
</script>
<style>
    /* Logo */
    #logo-portal-small {
        display: none;
        margin-right: 10px;
        max-width: 24px; 
        padding-bottom: 2px;
    }

    /*Toolbar buttons*/
    p {
        font-size: 14px;
    }

    .toolbar__items {
        height: auto !important;
    }

    .list__tile {
        font-size: 13px !important;
        text-decoration: none !important;
    }

    /**Navigation Bar Style **/

    .list__tile {
        font-size: 13px !important;
        text-decoration: none !important;
    }

    .list--dense {
        padding-top: 17px;
    }

    .subheader {
        padding-left: 0px;
    }

    .list__tile__title {
        padding-left: 18px;
    }

    .list__tile__title.sub-text-deactive {
        padding-left: 50px;
        color: green;
    }

    .list__tile__title.heading-active {
        padding-left: 0px;
    }

    /*Align buttons hover*/
    toolbar__side-icon.btn.btn--icon {
        margin: -6px;
    }

    .toolbar-icons .btn__content {
        margin: 0px !important;
    }

    /*Toolbar title*/
    #company-title {
        margin-bottom: -29px;
        margin-left: -61px;
        color: aqua;
    }

    #company-title span {
        font-size: 10px;
        font-weight: lighter;
    }

    .fixed-many {
        position: fixed!important;
        top: 48px!important;
    }

    @media only screen and (min-width: 960px) {
        .fixed-many {
            top: 64px!important;
        }
    }

    @media only screen and (max-width: 610px) {
        #main-content {
            margin-bottom: 35px;
        }
    }

    .v-toolbar__extension {
        background: #2f2f2f;
    }

    @media only screen and (max-width: 599px) {
        .v-toolbar .v-toolbar__content, .v-toolbar .v-toolbar__extension {
            padding-left: 12px;
            padding-right: 12px;
        }

        #logo-portal {
            display: none;
        }

        #logo-portal-small {
            display: inline;
        }
    }

</style>

<style>
  .mainNavDrawer .v-list-group .v-list-group__header {
    padding-left: 0;
  }
</style>
